import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from './axiosBaseQuery'
import { baseUrl } from './axiosInstance'

const companyApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'companyApi',
  tagTypes: ['company', 'audience', 'profile'],
  endpoints: () => ({})
})

export default companyApi
